import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BasePageComponent } from '../../commons/base-page/base-page.component';
import { PagingController } from '../../../shared/commons/paging-controller/paging-controller';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { ChannelItem } from '../../../data/btv/model/channel-item';
import { ChannelP } from '../../../data/360-client-api';
import { BtvDataRestService } from '../../../data/btv/btv-data-rest.service';

declare var videojs;


@Component({
  selector: 'app-channel-grid',
  templateUrl: './channel-grid.component.html',
  styleUrls: ['./channel-grid.component.css'],
  providers: [PagingController]
})
export class ChannelGridComponent extends BasePageComponent implements OnInit, OnDestroy {

  public title: string;
  public channels: Array<ChannelP>;
  public listID: string | null;
  channelUrls: string[] = [
    "https://bitdash-a.akamaihd.net/content/MI201109210084_1/m3u8s/f08e80da-bf1d-4e3d-8899-f0f6155f6efa.m3u8",
    "https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8",
    "https://mnmedias.api.telequebec.tv/m3u8/29880.m3u8",
    "http://184.72.239.149/vod/smil:BigBuckBunny.smil/playlist.m3u8",
    "http://www.streambox.fr/playlists/test_001/stream.m3u8"
  ];
  selectedChannel: ChannelP;
  index: number = 0;
  player: any;

  constructor(helpers: HelpersService,
    private router: Router,
    private dataSource: BtvDataRestService,
    private route: ActivatedRoute,
    public paging: PagingController) {
    super(helpers);
    // route.params.subscribe(val => {
    //   this.parseParams();
    // });
    // route.queryParams.subscribe(val => {
    //   this.parseParams();
    // });
    paging.pageChanged.subscribe(() => {
      this.getContent();
    });
  }

  ngOnInit() {
    this.paging.init(0, 0, 12);
    this.playPlayer();
    
  }

  playPlayer() {
    setTimeout(() => {
      this.player = videojs('video-player');
      this.player.src([
        { type: 'application/x-mpegURL', src: this.channelUrls[this.index] }
      ]);
    })
  }

  destroyPlayer() {
    this.player.dispose();
    this.player = null;
  }

  ngOnDestroy(): void {
    // this.paging.destroy();
    this.destroyPlayer();
  }

  selectChannel(channel) {
    this.selectedChannel = channel;
    ++this.index;
    if (this.index == 5) {
      this.index = 0;
    }
    this.playPlayer();

  }

  private getContent() {
    this.listID = this.route.snapshot.paramMap.get('id');
    this.dataSource.getChannels().subscribe(data => {
      this.channels = [];
      this.paging.update(data.length);
      if (this.listID == "Tüm Kanallar") {
        this.channels = data;
      }
      else {
        data.forEach(channel => {
          if (channel.genre == this.listID) {
            this.channels.push(channel)
          }
        });
      }
      this.selectedChannel = this.channels[0];
      this.channels = this.channels.slice(this.paging.current * this.paging.pageSize, (this.paging.current + 1) * this.paging.pageSize);
    });

  }

  public getUrl(channel: ChannelItem): string {
    return [
      window.location.protocol, '//',
      window.location.hostname,
      !(window.location.port === '80' || window.location.port === '443') ? ':' + window.location.port : '',
      this.router.createUrlTree(['/channelDetail', channel.id]).toString()
    ].join('');
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/btv/channel-grid/channel-grid.component.ts